<template>
    <div class="square-container">
        <div class="main-square">

            <div class="header-section">
                About Flow

            </div>
            <div class="section1">
                <div class="section1-titles">
                    <div class="flow-name">Flow Name:</div>
                    <div class="flow-description">Description:</div>
                    <div class="flow-ranking">Rankings:</div>
                    <div class="flow-comments">Comments:</div>
                </div>

                <div class="section1-content">
                    <div class="content-name">{{ contractAddress }}</div>
                    <div class="content-description">Description Content</div>
                    <div class="content-ranking">fdgdfg</div>
                    <div class="content-comments">Comments Content</div>


                </div>

            </div>
            <div class="section2">
                <div class="section2-titles">
                    Top Positive Comments
                </div>
            </div>
            <div class="section3">
                <div class="section3-titles">
                    Top Negative Comments
                </div>
            </div>
            <div class="section4">
                <div class="section4-titles">
                    <div>Params </div>
                    <div>{{ typeName }}</div>
                </div>

                <div class="params-container">
                    <div class="function-names" v-for="(input, index) in clickedFunction.inputs" :key="index">{{ input.name
                    }}
                        <template v-if="input.type === 'address'">
                            <textBox />
                        </template>

                        <template v-if="input.type === 'bool'">
                            <radioButton />
                        </template>

                        <template v-if="input.type === 'uint256'">
                            <uint256Box />
                        </template>

                        <template v-if="input.type === 'hex'">
                            <hexTextBox />
                        </template>



                    </div>
                    <!-- this is mvp functionality and technical debt, -->
                    <div v-if="stateTypes === 'nonpayable'"> 
                        <UniSwapTrade />
                    </div>

                    <div v-if="stateTypes === 'view'">
                        <SendToken />
                    </div>
                    <div v-if="stateTypes === 'payable'">
                        <SwapThree />
                    </div>


                </div>


            </div>
        </div>
    </div>
</template>
  
<script>
import textBox from './textBox.vue';
import radioButton from './radioButton.vue';
import hexTextBox from './hexTextBox.vue';
import uint256Box from './uint256Box.vue';
import UniSwapTrade from './UniSwapTrade.vue';
import SendToken from './SendToken.vue';
import SwapThree from './SwapThree.vue';

export default {
    components: {
        textBox,
        radioButton,
        hexTextBox,
        uint256Box,
        UniSwapTrade,
        SendToken,
        SwapThree,



    },

    props: {
        contractId: {
            type: String,
            required: true
        },
        functionIndex: {

            required: true
        }
    },

    data() {
        return {

            contractAddress: '',
            inputNames: '',
            clickedFunction: [],

            selectedContractId: null

        };
    },
    mounted() {
        this.getContractData();
    },

    methods: {
        async getContractData() {



            const response = await fetch(`http://localhost:12345/api/v1/sourcify/${this.contractId}`); //0x0000000000003f5e74C1ba8A66b48E6f3d71aE82
            // const response = await fetch(`http://174.107.99.75:12345/api/v1/sourcify/0x0000000000003f5e74C1ba8A66b48E6f3d71aE82`);

            const data = await response.json();


            this.contractAddress = data._id;
            this.clickedFunction = data.output.abi[this.functionIndex];

            this.inputNames = this.clickedFunction.inputs.map(input => input.name)

            this.inputTypes = this.clickedFunction.inputs.map(input => input.type)

            this.typeName = this.clickedFunction.name

            /* console.log(this.typeName)

            console.log(this.clickedFunction)

            console.log(this.inputTypes) */

            this.stateTypes = this.clickedFunction.stateMutability
            
            console.log(this.stateTypes)

            console.log(this.contractId);

            console.log(this.functionIndex)


        }
    }
};

</script>
  
<style>
.square-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;

}

.main-square {
    width: 70%;
    height: 70%;
    bottom: 0%;
    
    border-radius: .5%;
    display: grid;
    grid-template-rows: 10% 30% 30% 30% 90%;
    grid-template-columns: 60%;
    grid-template-areas:
        "header"
        "section1"
        "section2"
        "section3"




    ;
    position: relative;

}



.header-section {
    grid-area: header;
    width: 166.6%;

    border-top-left-radius: 10px;
    text-align: center;
    padding-top: .5%;
    font-weight: bold;
    font-size: 24pt;
    border-bottom: 3px solid black;

}

.section1 {
    grid-area: section1;
    border-bottom: 3px solid black;

    display: flex;
    align-items: center;


}

.section1-head {
    text-align: center;
    padding-top: .0%;
    font-weight: bold;
    font-size: 24pt;
}

.section1-titles,
.section1-content {
    display: flex;
    flex-direction: column;


}

.section1-titles div,
.section1-content div {
    margin-bottom: 30px;

}

.section1-content {
    margin-left: 20px;
    /*move content further right of titles */
}

.section1-titles {
    font-weight: bold;
    text-align: left;
    padding-left: 2%;

}

.section1-content {
    text-align: left;
}



.section2 {
    grid-area: section2;
    border-bottom: 3px solid black;


}

.section2-titles {
    text-align: center;
    padding-top: .5%;
    font-weight: bold;
    font-size: 24pt;


}



.section3 {
    grid-area: section3;

    border-bottom-left-radius: 10px;

}

.section3-titles {
    text-align: center;
    padding-top: .5%;
    font-weight: bold;
    font-size: 24pt
}



.section4 {
    position: absolute;
    width: 40%;
    top: 10%;
    left: 60%;
    height: 90%;
    border-left: 3px solid black;



}

.params-container {
    display: flex;
    flex-direction: column;

}

.function-names {
    font-weight: bold;
    text-align: left;
    padding-left: 2%;
    padding-bottom: 5%;
}

.input-fields {
    text-align: left;
    margin-left: 20px;
}

.function-names,
.input-fields {
    display: flex;
    flex-direction: column;
}

.section4-titles {
    text-align: center;
    padding-top: .5%;
    font-weight: bold;
    font-size: 24pt;


}



.toAddress-text,
.amount-text {
    margin: 10px auto;
    /* add some space between the inputs */
    width: 80%;
    /* adjust as needed */
    padding: 10px;
    /* add some padding for the text */
    border-radius: 4px;
    /* adjust as needed */
    font-size: larger;
    /* adjust as needed */
    border: 2px solid black;
    /* adjust as needed */
}

.toAddress-text {

    margin-bottom: 30px;
    margin-top: 50px;
}

.amount-text {
    margin-bottom: 10px;
}

.send-button {
    margin: 50px;
    padding: 10px 50px;
    font-size: 2rem;
    border-radius: 5px;
    border: black;
    background-color: #000000;
    /* Green */
    color: rgb(255, 255, 255);
}
</style>
  //  .flow-name {
    font-weight: bold;
    text-align: left;
}
.flow-description {
    font-weight: bold;
    text-align: left; 
}
.flow-ranking {
    font-weight: bold;
    text-align: left;
}
.flow-comments {
    font-weight: bold;
    text-align: left;
}





<input class="toAddress-text" type="text" placeholder="To Addr">
<input class="amount-text" type="text" placeholder="Amount">
<button class="send-button">Send</button>